// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SystemSelfManagementOutlinedSvg from "@fishx/icons-svg/es/asn/SystemSelfManagementOutlined";
import FishxIcon from '../components/FishxIcon';

var SystemSelfManagementOutlined = function SystemSelfManagementOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SystemSelfManagementOutlinedSvg
  }));
};

SystemSelfManagementOutlined.displayName = 'SystemSelfManagementOutlined';
export default React.forwardRef(SystemSelfManagementOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SystemSelfManagementOutlined.js
// module id = 4226
// module chunks = 0